// Shared number formatting so every screen shows amounts the same way.

// $1,234.56 — always two decimals ('' when not a number).
export function money(v) {
  const n = parseFloat(v);
  if (isNaN(n)) return '';
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

// $1,234 when whole dollars, $1,234.56 only when there are cents ('' when not a
// number). Rounds to cents first, so a computed 299.99999999999997 shows $300.
export function moneyWhole(v) {
  const raw = parseFloat(v);
  if (isNaN(raw)) return '';
  const n = Math.round(raw * 100) / 100;
  const whole = Number.isInteger(n);
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
}

// Hours / quantities: up to `digits` decimals, no trailing zeros ('' when not a number).
export function hours(v, digits = 2) {
  const n = parseFloat(v);
  if (isNaN(n)) return '';
  return n.toLocaleString('en-US', { maximumFractionDigits: digits });
}

// Percent of a 0-100 value, e.g. 42.5 -> "42.5%" ('' when not a number).
export function pct(v, digits = 1) {
  const n = parseFloat(v);
  if (isNaN(n)) return '';
  return `${n.toLocaleString('en-US', { maximumFractionDigits: digits })}%`;
}
